<template>
    <div>
        <modal :backdrop="false" size="lg" v-model="modal">
            <div slot="header">
                <button @click.prevent="closeModal" class="close" type="button">×</button>
                <div class="row">
                    <div class="col-xs-6"><h4 class="smalltitle">Add Staff Member</h4></div>
                </div>
            </div>
            <div class="block-body">
                <div class="prolabel note">Add new</div>
                <div class="profield">
                    <label class="inline-checkbox">
                        <input type="radio" name="stafftype" :value="TYPE_PHYSICIAN"
                               v-model="staffType" @change="changeStaffType"> Physician
                    </label>&nbsp;
                    <label class="inline-checkbox">
                        <input type="radio" name="stafftype" :value="TYPE_STAFF"
                               v-model="staffType" @change="changeStaffType"> Clinic Staff
                    </label>
                </div>

                <div class="prolabel note">User</div>
                <div class="profield">
                    <div class="row">
                        <div class="col-xs-8">
                            <input type="text" v-model="searchText" @keyup.enter="fetchUsers"
                                   placeholder="Search WikiAllergies user by name or email">
                        </div>
                        <div class="col-xs-4">
                            <button class="btn light informbtn" @click="fetchUsers()">
                                <i class="fas fa-spinner fa-spin" v-if="processingSearch"></i> Search
                            </button>
                        </div>
                    </div>
                </div>

                <div class="profield fullw">
                    <ul class="itemlisttable searchuserlist samebglist">
                        <li class="itemlisthead">
                            <div style="width: 30%;">User name</div>
                            <div style="width: 30%;">Email</div>
                            <div style="width: 12%;">DOB</div>
                            <div style="width: 13%;">User type</div>
                            <div style="width: 15%;text-align: right;">Action</div>
                        </li>
                        <li v-for="result in searchResult">
                            <div style="width: 30%;"><span style="font-weight: bold">{{result.fullName}}</span></div>
                            <div style="width: 30%;min-height: 1px;">{{result.email}}</div>
                            <div style="width: 12%;min-height: 1px;">{{result.birthday}}</div>
                            <div style="width: 13%;min-height: 1px;">
                                {{isDoctor(result) ? 'Physician' : 'Regular User'}}
                            </div>
                            <div style="width: 15%;text-align: right;">
                                <label class="inline-checkbox" v-if="result.addedStatus === 'NotAdd'">
                                    <input type="radio" name="searchusercheck" :value="result.id"
                                           @click="chooseUser(result)"> Choose
                                </label>
                                <label class="inline-checkbox" v-else>{{result.addedStatus}}</label>
                            </div>
                        </li>
                        <li v-if="searched && searchResult.length === 0">
                            <div style="width: 100%;">Can't find name "{{searchText}}"</div>
                        </li>
                    </ul>
                </div>

                <div class="prolabel note">Permission</div>
                <div class="profield checkboxbegin">
                    <div v-if="staffType === TYPE_PHYSICIAN">
                        <label class="inline-checkbox">
                            <input type="checkbox" v-model="dataItem.showOnProfile"> Display on clinic's profile
                        </label>
                        <a class="light" href="javascript:void(0)"
                           v-popover.right.hover="{content:'Patient can request appointment with the allergist from your clinic profile page.'}">(?)</a>
                    </div>
                    <div v-if="staffType === TYPE_STAFF">
                        <label class="inline-checkbox">
                            <input type="radio" name="permission" :value="PERMISSION_CLINIC_STAFF"
                                   v-model="dataItem.permission"> Clinic staff
                        </label>
                        <a class="light" href="javascript:void(0)"
                           v-popover.right.hover="{content:'Clinic staff (security level of permission to assess the EMR software can be set at the clinic EMR at Setting/Security section)'}">(?)</a>
                        <br>
                        <label class="inline-checkbox">
                            <input type="radio" name="permission" :value="PERMISSION_MID_LEVEL"
                                   v-model="dataItem.permission"> Mid-level Provider
                        </label>
                        <a class="light" href="javascript:void(0)"
                           v-popover.right.hover="{content:'Mid-level provider (physician assistant or nurse practitioner).'}">(?)</a>
                    </div>
                </div>

                <div v-if="isMidLevel">
                    <div class="prolabel note">Supervising physician</div>
                    <div class="profield">
                        <select v-model="dataItem.doctorManage">
                            <option value="">---Please select---</option>
                            <option v-for="physician in physicians" :value="physician.id">{{physician.fullName}}</option>
                        </select>
                    </div>
                </div>

                <div v-if="staffType === TYPE_STAFF">
                    <div class="prolabel note">Display on clinic's profile</div>
                    <div class="profield">
                        <label class="inline-checkbox">
                            <input type="radio" v-model="dataItem.showOnProfile" :value="true"> Yes
                        </label>&nbsp;
                        <label class="inline-checkbox">
                            <input type="radio" v-model="dataItem.showOnProfile" :value="false"> No
                        </label>
                    </div>

                    <div class="prolabel note">Position</div>
                    <div class="profield">
                        <input type="text" v-model="dataItem.position"
                               placeholder="Description of your staff's position and role">
                    </div>
                </div>

                <div v-if="staffType === TYPE_PHYSICIAN">
                    <div class="prolabel note fullw">
                        <div class="row">
                            <div class="col-xs-5">Location</div>
                            <div class="col-xs-7" style="padding-left: 3px;">Work Hours</div>
                        </div>
                    </div>
                    <div class="profield fullw">
                        <div v-if="locations.length === 0" style="padding-left: 15px;">
                            This clinic has no location.
                        </div>
                        <div class="row locationblock" v-for="location in locations">
                            <div class="col-xs-5">
                                <label class="inline-checkbox">
                                    <input type="checkbox" v-model="location.selected">
                                    <strong>{{location.name}}</strong><br>
                                    <em>{{formatAddress(location)}}</em>
                                </label>
                            </div>
                            <div class="col-xs-7 workingtime" v-if="location.selected">
                                <label class="inline-checkbox">
                                    <input type="radio" :name="'followTime' + location.id" :value="1"
                                           v-model="location.followTime"> Follow clinic's open-hour
                                </label>&nbsp;
                                <label class="inline-checkbox">
                                    <input type="radio" :name="'followTime' + location.id" :value="0"
                                           v-model="location.followTime"> Custom working time
                                </label>

                                <div class="timetypeform" v-if="Number(location.followTime) === 0">
                                    <ul class="weekdaylist">
                                        <li v-for="week in WEEK" :class="{'cur': location.selectedDate === week}"
                                            @click="location.selectedDate = week">{{week}}
                                        </li>
                                        <li class="clearbut">
                                            <a class="light" href="javascript:void(0)"
                                               @click.prevent="clearAllOpenHour(location)"
                                               title="Clear all open hours">Clear all hours</a>
                                        </li>
                                    </ul>
                                    <ul class="openhour box boxend" v-if="location.openHourData.length">
                                        <li v-for="hour in location.openHourData">
                                            {{hour.date}} - {{hour.from}} - {{hour.to}}
                                            <span class="delete" title="Delete this working time"
                                                  @click="deleteWorkingHour(location, hour)"></span>
                                        </li>
                                    </ul>
                                    <div class="row">
                                        <div class="col-xs-4">
                                            <select v-model="location.selectedFrom">
                                                <option v-for="time in TIME_OPTIONS" :value="time">{{time}}</option>
                                            </select>
                                        </div>
                                        <div class="col-xs-4">
                                            <select v-model="location.selectedTo">
                                                <option v-for="time in TIME_OPTIONS" :value="time">{{time}}</option>
                                            </select>
                                        </div>
                                        <div class="col-xs-4">
                                            <button class="btn light" @click.prevent="addWorkingHour(location)">Add
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="clearfix"></div>
                        </div>
                    </div>
                </div>
            </div>
            <div slot="footer">
                <button type="button" @click="addStaff()" class="btn btn-default">
                    <i class="fas fa-spinner fa-spin" v-if="processingAdd"></i> Add
                </button>
                <button @click.prevent="closeModal" class="btn btn-default" type="button">Close</button>
            </div>
        </modal>
    </div>
</template>

<script>
import httpClient from '../../../client'
import CommonMixin from '../../../mixins/general/CommonMixin.vue'

const TYPE_PHYSICIAN = 'physician'
const TYPE_STAFF = 'staff'
const STATUS_CONFIRMED = 2

// 7:00 AM -> 6:30 PM, bước 30 phút - giống patternWorkingHour bên wikiallergies
const buildTimeOptions = () => {
  let times = ['']
  for (let hour = 7; hour < 19; hour++) {
    for (let minute = 0; minute < 60; minute += 30) {
      let suffix = hour < 12 ? 'AM' : 'PM'
      let hourText = hour <= 12 ? hour : hour - 12
      times.push(`${hourText}:${('0' + minute).slice(-2)} ${suffix}`)
    }
  }
  return times
}

export default {
  name: 'AddStaffModal',
  components: {},
  props: {
    clinic: {}
  },
  mixins: [CommonMixin],
  data () {
    return {
      modal: false,
      TYPE_PHYSICIAN: TYPE_PHYSICIAN,
      TYPE_STAFF: TYPE_STAFF,
      PERMISSION_CLINIC_STAFF: 'ClinicStaff',
      PERMISSION_MID_LEVEL: 'MidLevel',
      WEEK: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
      TIME_OPTIONS: buildTimeOptions(),
      staffType: TYPE_PHYSICIAN,
      searchText: '',
      searchResult: [],
      searched: false,
      searchId: 0,
      locations: [],
      physicians: [],
      dataItem: {
        showOnProfile: false,
        permission: '',
        position: '',
        doctorManage: ''
      },
      processingSearch: false,
      processingAdd: false
    }
  },
  computed: {
    isMidLevel () {
      return this.staffType === TYPE_STAFF && this.dataItem.permission === this.PERMISSION_MID_LEVEL
    }
  },
  watch: {
    'modal' (newValue) {
      this.$emit('updateModal', newValue)
    }
  },
  mounted () {
    this.modal = true
    this.loadLocations()
    this.loadPhysicians()
  },
  methods: {
    isDoctor (user) {
      return ['physician', 'allergist'].indexOf(user.role) > -1
    },
    formatAddress (location) {
      let parts = [location.streetNumber, location.streetName]
      let street = parts.filter(item => !!item).join(' ')
      if (location.suite) {
        street += ` #${location.suite}`
      }
      return [street, location.city, location.state].filter(item => !!item).join(', ')
    },
    changeStaffType () {
      this.searchText = ''
      this.searchResult = []
      this.searched = false
      this.searchId = 0
      this.dataItem = this.$options.data().dataItem
      this.locations.forEach(location => {
        location.selected = false
        location.openHourData = []
      })
    },
    chooseUser (user) {
      this.searchId = user.id
    },
    addWorkingHour (location) {
      if (!location.selectedFrom || !location.selectedTo) {
        this.alertError('Please choose working hours')
        return
      }
      location.openHourData.push({
        date: location.selectedDate,
        from: location.selectedFrom,
        to: location.selectedTo
      })
      location.selectedFrom = ''
      location.selectedTo = ''
    },
    deleteWorkingHour (location, hour) {
      let index = location.openHourData.indexOf(hour)
      if (index > -1) {
        location.openHourData.splice(index, 1)
      }
    },
    clearAllOpenHour (location) {
      location.openHourData = []
    },
    async loadLocations () {
      try {
        let response = await httpClient.get('/clinic/staff/locations', {
          params: { clinicId: this.clinic.id }
        })
        if (response.data.s !== 200) {
          this.alertError(response.data.msg)
          return
        }
        this.locations = response.data.data.map(location => {
          return {
            ...location,
            selected: false,
            followTime: 1,
            selectedDate: 'Mon',
            selectedFrom: '',
            selectedTo: '',
            openHourData: []
          }
        })
      } catch (e) {
        this.alertError('Server error when get location of clinic')
      }
    },
    async loadPhysicians () {
      try {
        let response = await httpClient.get('/users/list-member-clinic', {
          params: { userId: this.clinic.id, typeStaff: TYPE_PHYSICIAN, page: 1, perPage: 100 }
        })
        if (response.data.s === 200) {
          this.physicians = response.data.data.members || []
        }
      } catch (e) {
        this.physicians = []
      }
    },
    async fetchUsers () {
      if (this.processingSearch || !this.searchText) {
        return
      }
      this.processingSearch = true
      try {
        let response = await httpClient.get('/clinic/staff/search', {
          params: {
            clinicId: this.clinic.id,
            searchText: this.searchText,
            typeStaff: this.staffType
          }
        })
        this.processingSearch = false
        if (response.data.s !== 200) {
          this.alertError(response.data.msg)
          return
        }
        let users = response.data.data.users || []
        let addeds = response.data.data.addedIds || []
        this.searchResult = users.map(user => {
          user.birthday = user.birthday ? this.formatBirthday(user.birthday) : ''
          user.addedStatus = 'NotAdd'
          addeds.some(added => {
            if (Number(added.staff_id) === Number(user.id)) {
              // chỉ chặn chọn khi đã là member thật sự, các trạng thái còn lại cho add lại
              user.addedStatus = Number(added.status) === STATUS_CONFIRMED ? 'Added' : 'NotAdd'
              return true
            }
          })
          return user
        })
        this.searched = true
      } catch (e) {
        this.processingSearch = false
        this.alertError('Server error when search user')
      }
    },
    formatBirthday (birthday) {
      let date = new Date(birthday)
      return ('0' + (date.getMonth() + 1)).slice(-2) + '/' + ('0' + date.getDate()).slice(-2) + '/' + date.getFullYear()
    },
    async addStaff () {
      if (this.processingAdd) {
        return
      }
      if (!this.searchId) {
        this.alertError('Please choose user')
        return
      }
      if (this.staffType === TYPE_STAFF && !this.dataItem.permission) {
        this.alertError('Please choose permission for this staff')
        return
      }
      if (this.isMidLevel && !this.dataItem.doctorManage) {
        this.alertError('Please choose supervising physician')
        return
      }
      let locations = []
      if (this.staffType === TYPE_PHYSICIAN) {
        locations = this.locations.filter(location => location.selected).map(location => {
          return {
            id: location.id,
            followTime: location.followTime,
            openHourData: location.openHourData
          }
        })
      }
      this.processingAdd = true
      try {
        let response = await httpClient.post('/clinic/staff/add', {
          clinicId: this.clinic.id,
          staffId: this.searchId,
          typeStaff: this.staffType,
          showOnProfile: this.dataItem.showOnProfile,
          permission: this.dataItem.permission,
          position: this.dataItem.position,
          doctorManage: this.dataItem.doctorManage,
          locations: locations
        })
        this.processingAdd = false
        if (response.data.s !== 200) {
          this.alertError(response.data.msg)
          return
        }
        // EMR sync lỗi thì staff vẫn đã vào clinic, báo để còn xử lý tay
        if (response.data.data && response.data.data.syncedEmr === false) {
          this.alertError(response.data.msg)
        } else {
          this.alertSuccess('Add staff success')
        }
        this.$emit('addStaff')
        this.modal = false
      } catch (e) {
        this.processingAdd = false
        this.alertError('Server error.Try again later')
      }
    },
    closeModal () {
      this.modal = false
    }
  }
}
</script>
<style scoped="">
    .weekdaylist li {
        cursor: pointer;
    }

    .locationblock {
        padding: 8px 0;
    }
</style>
